import { SearchOrigins, SearchUrlParamKeys } from 'search-gateway-client';

const CONVERSATIONAL_SEARCH_PATH = '/ai/conv-search/new';

export default function getConversationalSearchUrl(prompt: string, searchOrigin: SearchOrigins): string {
    const params = new URLSearchParams({
        [SearchUrlParamKeys.SEARCH_ORIGIN]: searchOrigin,
        prompt,
    });
    return `${CONVERSATIONAL_SEARCH_PATH}?${params.toString()}`;
}
